import { DeepThoughtsIntro } from "@/components/conversations/activities/deep-thoughts/deep-thoughts-intro";
import {
  useSendActivity,
  type DeepThoughtsPrerequisitesStatus,
} from "@/lib/api/activities";
import { usePostHogEvent } from "@/lib/posthog";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

interface DeepThoughtsSendHostProps {
  isOpen: boolean;
  prereqs: DeepThoughtsPrerequisitesStatus | null;
  onOpenChange: (open: boolean) => void;
  mentorshipId: string;
  teenName: string;
  onOpenHotTakes: () => void;
  onOpenConnectionCards: () => void;
}

export function DeepThoughtsSendHost({
  isOpen,
  prereqs,
  onOpenChange,
  mentorshipId,
  teenName,
  onOpenHotTakes,
  onOpenConnectionCards,
}: DeepThoughtsSendHostProps) {
  const queryClient = useQueryClient();
  const sendMutation = useSendActivity();
  const { dispatchEvent } = usePostHogEvent("activity.mentor");

  const handleSend = useCallback(() => {
    sendMutation.mutate(
      { mentorshipId, activityType: "deep_thoughts" },
      {
        onSuccess: () => {
          dispatchEvent("activity.mentor.sent", {
            mentorshipId,
            activityType: "deep_thoughts",
          });
          onOpenChange(false);
          void queryClient.invalidateQueries({
            queryKey: ["mentorship", mentorshipId],
          });
        },
      },
    );
  }, [dispatchEvent, mentorshipId, queryClient, sendMutation, onOpenChange]);

  return (
    <DeepThoughtsIntro
      prereqs={prereqs}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      teenName={teenName}
      isSending={sendMutation.isPending}
      onOpenHotTakes={() => {
        onOpenChange(false);
        onOpenHotTakes();
      }}
      onOpenConnectionCards={() => {
        onOpenChange(false);
        onOpenConnectionCards();
      }}
      onSend={handleSend}
    />
  );
}
